import React,{useState,useCallback} from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStopCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalHead from './ModalHead';
import Toast from './Toast';
import Ajax from './Ajax';
import {Play,EventParam} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';
import Loading from './Loading';
import EventEmpty from './EventEmpty';
import EventBottles from './EventBottles';
import EventDetox from './EventDetox';
import EventMachine from './EventMachine';
import EventWrite from './EventWrite';
import EventRead from './EventRead';
import EventBed from './EventBed';

interface Props {
    play:Play,
    param:EventParam,
    uid:string,
    close(play:Play):void,
}

const Room = (props:Props)=> {
    Ajax.setUid(props.uid)
    const classes = Styles.base();
    library.add(faStopCircle);

	const [states,setStates] = useState({
        isLoading:false,
        gold: props.play.gold,
        toast: "",
    });
    const closeToast = ()=>{
        setStates({...states,toast:""});
    }
    const close = (play:Play)=>{
        props.close(play);
    }
    //const stop = ()=>{
    //    props.close(props.play);
    //}
    const gold = (num:number) =>{
        setStates({...states,gold:states.gold+num});
    }
    const golds = useCallback( (num:number)=>{
        let tmp:any[] = [];
        for( let i=0 ; i<num ; i++ ){
            const key = "gold"+i;
            tmp.push(
                <FontAwesomeIcon key={key} icon="stop-circle" style={{color:"silver"}}/>
            );
        }
        return tmp;
    },[]);

    const title = Tools.roomName(props.play.floor_num,props.play.room_num) + "号室";

    return (
        <div id="room" className={classes.modalRoot}>
            <ModalHead title={title}/>
            <div className={classes.golds}>
                {golds(states.gold)}
            </div>
            <div style={{marginTop:"0em"}}>
            {props.param.event.type_id===0 &&
                <EventEmpty play={props.play} param={props.param} gold={gold} close={close}/>
            }

            {props.param.event.type_id===1 &&
                <EventBottles play={props.play} param={props.param} close={close}/>
            }

            {props.param.event.type_id===2 &&
                <EventDetox play={props.play} param={props.param} gold={gold} close={close}/>
            }

            {props.param.event.type_id===3 &&
                <EventMachine play={props.play} param={props.param} gold={gold} close={close}/>
            }

            {props.param.event.type_id===4 &&
                <EventWrite uid={props.uid} play={props.play} param={props.param} close={close}/>
            }

            {props.param.event.type_id===5 &&
                <EventRead play={props.play} param={props.param} close={close}/>
            }

            {props.param.event.type_id===9 &&
                <EventBed play={props.play} param={props.param} gold={gold} close={close}/>
            }
            </div>

            <Loading isLoading={states.isLoading}/>
            <Toast close={closeToast} mes={states.toast}/>
        </div>
    );
}

export default Room;
